export default "__VITE_ASSET__NZ4r1UAW__"